import LoginLink from 'app/components/auth/LoginLink';
import LogoutLink from 'app/components/auth/LogoutLink';
import { useI18n } from 'app/components/localization';
import { isAuthenticatedSelector } from 'app/models/auth/selectors';
import { AppState } from 'app/store';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';

interface IProps {
  className: string;
  loggedIn: boolean;
}
const AuthLink: FunctionComponent<IProps> = ({ loggedIn, ...rest }) => {
  const { t } = useI18n();

  if (loggedIn) {
    return (<LogoutLink {...rest}>{t('page.teach.header.sign-out')}</LogoutLink>);
  } else {
    return (<LoginLink {...rest}>{t('page.teach.header.sign-in')}</LoginLink>);
  }
};

const mapStateToProps = (state: AppState) => ({
  loggedIn: isAuthenticatedSelector(state),
});

export default connect(mapStateToProps, {})(AuthLink);
